/* eslint-disable @next/next/no-img-element */
import ModalWrapper from "@/components/shared/ModalWrapper/ModalWrapper";
import { RootState } from "@/redux/store";
import { useSelector } from "react-redux";

import styles from "./InniSoulmateModal.module.css";
import { useModalContext } from "@/context/ModalContext";
import CloseButtonSummary from "@/components/shared/CloseButtonSummary";
import { MemberGender } from "@dimensional-engineering/dimensional-models";
import { Mixpanel } from "@/helpers/mixpanel";
import { useAuth } from "@/context/AuthContext";
import { openInNewTab } from "@/components/shared/utils";

export default function InniSoulmateModal() {
  const { setModalOpen } = useModalContext();
  const gender = useSelector(
    (state: RootState) => state.user.publicProfileData?.memberGender,
  );

  const { user } = useAuth();

  const handleClick = () => {
    Mixpanel?.track(
      "INNI download CTA pressed",
      {
        source: "INNI notification ad",
      },
      user?.uid,
    );

    if (window.Android) {
      window.Android.openInNewTab(
        "https://play.google.com/store/apps/details?id=com.dimensional.inni",
      );
    } else {
      openInNewTab(
        "https://play.google.com/store/apps/details?id=com.dimensional.inni",
      );
    }
  };

  return (
    <ModalWrapper noHeader title="">
      <main className={styles.main}>
        <div onClick={() => setModalOpen(false)} className={styles.closeButton}>
          <CloseButtonSummary />
        </div>
        <img src="/inni/icon-with-text.png" alt="" className={styles.icon} />
        <div className={styles.wrapper}>
          <h1 className={styles.title}>Find your soulmate</h1>
          <h4 className={styles.desc}>
            {
              "INNI, our sister app, uses advanced personality science to match you with people you're truly compatible with."
            }
          </h4>
          <div className={styles.imageWrapper}>
            <img
              className={styles.image}
              alt=""
              src={gender === "female" ? "/inni/male.png" : "/inni/female.png"}
            />
          </div>
        </div>
        <div className={styles.bottom}>
          <button onClick={handleClick} className={styles.btn}>
            Download on the PlayStore
          </button>
        </div>
      </main>
    </ModalWrapper>
  );
}
